<template>
  <div class="doctorInfo">
    <img class="avatar" :src="doctorInfo.imgUuid" alt="">
    <div class="info">
      <p class="name" @click.prevent="handleClick">{{doctorInfo.name}}</p>
      <p class="rank">{{doctorInfo.level}}</p>
      <p class="num">接诊量：{{doctorInfo.orderCount}}(指定的医生不出诊或无号源时{{doctorInfo.isAgree == "0" ? "同意" : "不同意"}}同科室的其他医生。)</p>
      <p class="num">科室：{{doctorInfo.departmentName}}</p>
      <p class="good">擅长：{{doctorInfo.baseInfo}}</p>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  props: ['doctorInfo'],
  computed: {
    // ...mapState(['doctorInfo'])
  }
}
</script>

<style scoped lang="less" type="text/less">
.doctorInfo{
  display: flex;
  position: relative;
  width: 480px;
  box-sizing: border-box;
  margin-bottom: 20px;
  .avatar{
    float: left;
    display: block;
    width: 180px;
    height: 180px;
    margin-right: 20px;
    background: #ccc;
  }
  .info{
    width: 280px;
    .name{
      margin-bottom: 12px;
      font-size: 18px;
      font-weight: bold;
      font-family:PingFang-SC-Bold;
    }
    .rank{
      margin-bottom: 17px;
      color:#61aee6;
    }
    .num{
      margin-bottom: 15px;
    }
    .good{
      height: 61px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/DoctorInfo.vue